import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {httpClient} from '@/api/baseApi';
import {DiagItem} from '@/views/system/diagtasks/interfaces';
import {EntityModule} from './entities/entityModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {getEventData, getEventTypes, getLastEvents} from '@/store/modules/entities/pmodules/base';

/*
    Динамический модуль хранилища vuex для Задач диагностики
*/

const moduleName = 'diagtaskStoreModule';

function transformGet(elem: any): DiagItem {
  return {
    id: elem.id,
    name: elem.name,
    description: elem.description,
    accelerometer_guid: elem.accelerometer_guid,
    temperature_guid: elem.temperature_guid,
    accel: pmoduleModule.all.find(x => x.guid == elem.accelerometer_guid)?.name,
    taho_module_uuid: elem.taho_module_uuid,
    default_rotation_value: elem.default_rotation_value
      ? parseFloat(elem.default_rotation_value)
      : elem.default_rotation_value,
    rms_value: elem.rms_value ? parseFloat(elem.rms_value) : elem.rms_value,
    bearings: elem.bearings,
    frequencies: elem.frequencies,
  };
}

function transformCreateEdit(elem: any): DiagItem {
  return {
    name: elem.name,
    description: elem.description,
    accelerometer_guid: elem.accelerometer_guid,
    temperature_guid: elem.temperature_guid,
    taho_module_uuid: elem.taho_module_uuid,
    default_rotation_value: elem.default_rotation_value
      ? parseFloat(elem.default_rotation_value)
      : elem.default_rotation_value,
    rms_value: elem.rms_value ? parseFloat(elem.rms_value) : elem.rms_value,
    bearings: elem.bearings,
    frequencies: elem.frequencies,
  };
}

function transformSave(model: DiagItem): any {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    accelerometer_guid: model.accelerometer_guid,
    temperature_guid: model.temperature_guid,
    taho_module_uuid: model.taho_module_uuid,
    default_rotation_value: model.default_rotation_value ? model.default_rotation_value : null,
    rms_value: model.rms_value,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class DiagTaskStoreModule extends EntityModule {
  protected routeName = 'span-nodes';

  get all(): DiagItem[] {
    return super.all as DiagItem[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    await pmoduleModule.fetchAll();
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: DiagItem}> {
    return super.create(transformCreateEdit) as Promise<{data: DiagItem}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: DiagItem}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: DiagItem}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: DiagItem) {
    return super.save(model, transformSave);
  }

  //Добавление или редактирование подшипника
  @Action
  public async saveBearing(model: any) {
    try {
      if (model.bearing.id) {
        const responce = await httpClient.put(
          `${this.routeName}/${model.id}/bearing/${model.bearing.id}`,
          model.bearing,
        );
        return responce.data;
      } else {
        const responce = await httpClient.post(
          `${this.routeName}/${model.id}/bearing`,
          model.bearing,
        );
        return responce.data;
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Удаление подшипника
  @Action
  public async delBearing(model: any) {
    try {
      const responce = await httpClient.delete(
        `${this.routeName}/${model.itemId}/bearing/${model.bearingId}`,
      );
      return responce.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Добавление или редактирование частоты
  @Action
  public async saveFrequency(model: any) {
    try {
      if (model.frequency.id) {
        const responce = await httpClient.put(
          `${this.routeName}/${model.id}/frequency/${model.frequency.id}`,
          model.frequency,
        );
        return responce.data;
      } else {
        const responce = await httpClient.post(
          `${this.routeName}/${model.id}/frequency`,
          model.frequency,
        );
        return responce.data;
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Удаление частоты
  @Action
  public async delFrequency(model: any) {
    try {
      const responce = await httpClient.delete(
        `${this.routeName}/${model.itemId}/frequency/${model.frequencyId}`,
      );
      return responce.data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение типов событий
  @Action
  async getEventTypes(): Promise<any> {
    try {
      return await getEventTypes(this.routeName);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение списка последних событий
  @Action
  async getLastEvents(params: {id: number; eventType: string; limit?: number}): Promise<any> {
    try {
      return await getLastEvents(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Получение данных события
  @Action
  async getEventData(params: {id: number; eventType: string; timestamp: number}): Promise<any> {
    try {
      return await getEventData(this.routeName, params);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(DiagTaskStoreModule);
